/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_login_passkey_error = /** @type {(inputs: { message: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Passkey error: ${i?.message}`)
};

const zh_hans1_login_passkey_error = /** @type {(inputs: { message: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`通行密钥错误：${i?.message}`)
};

const zh_hant1_login_passkey_error = /** @type {(inputs: { message: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`通行金鑰錯誤：${i?.message}`)
};

const fr_login_passkey_error = /** @type {(inputs: { message: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Erreur passkey : ${i?.message}`)
};

const de_login_passkey_error = /** @type {(inputs: { message: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Passkey-Fehler: ${i?.message}`)
};

const ja_login_passkey_error = /** @type {(inputs: { message: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`パスキーエラー: ${i?.message}`)
};

const ko_login_passkey_error = /** @type {(inputs: { message: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`패스키 오류: ${i?.message}`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ message: NonNullable<unknown> }} inputs
* @param {{ locale?: "en" | "zh-Hans" | "zh-Hant" | "fr" | "de" | "ja" | "ko" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const login_passkey_error = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.login_passkey_error(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("login_passkey_error", locale)
	if (locale === "en") return en_login_passkey_error(inputs)
	if (locale === "zh-Hans") return zh_hans1_login_passkey_error(inputs)
	if (locale === "zh-Hant") return zh_hant1_login_passkey_error(inputs)
	if (locale === "fr") return fr_login_passkey_error(inputs)
	if (locale === "de") return de_login_passkey_error(inputs)
	if (locale === "ja") return ja_login_passkey_error(inputs)
	return ko_login_passkey_error(inputs)
};